// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var WebhooksController = function ($scope, $http, $routeParams, WebhookEvents, PUtill) {
    $scope.webhooksEvents = [
        "ContractCreated",
        "ContractChanged",
        "ContractCancelled",
        "ContractDeleted",
        "CustomerCreated",
        "CustomerChanged",
        "CustomerDeleted",
        "DunningCreated",
        "InvoiceCreated",
        "InvoiceCorrected",
        "OrderSucceeded",
        "RecurringBillingApproaching",
        "TrialEndApproaching",
        "DebitAuthCancelled",
        "PaymentBearerExpired",
        "PaymentBearerExpiring",
        "PaymentDataChanged",
        "PaymentEscalated",
        "PaymentEscalationReset",
        "PaymentFailed",
        "PaymentProcessStatusChanged",
        "PaymentStatusChanged",
        "PaymentRegistered",
        "PaymentSucceeded",
        "ReportSucceeded",
        "ReportFailed",
        "AcctExportSucceeded",
        "AcctExportFailed",
        "CustomerLocked",
        "CustomerUnlocked",
        "PlanCreated",
        "PlanChanged",
        "PlanDeleted",
        "PlanVariantCreated",
        "PlanVariantChanged",
        "PlanVariantDeleted",
        "ComponentCreated",
        "ComponentChanged",
        "ComponentDeleted",
        "InsufficientBalanceForNextBilling",
        "AutomaticDowngradeInsufficientBalance",
        "PaymentsExportFileCreated",
        "ContractWrittenOff",
        "PaymentDebtCollectionStatusChanged"];

    $scope.status = '';
    $scope.eventType = '';

    $scope.statusName = PUtill.getText('Status');
    $scope.eventName = PUtill.getText('Event');

    $scope.dateRange = { dateFrom: null, dateTo: null };

    let getSearchParams = function () {
        let searchParams = {
            dateFrom: $scope.dateRange.dateFrom,
            dateTo: PUtill.addDay($scope.dateRange.dateTo)
        };

        if ($scope.status)
            searchParams.status = $scope.status;

        if ($scope.hookEvent)
            searchParams.hookEvent = $scope.hookEvent;

        return searchParams;
    };

    $scope.updateFilter = function (func) {
        $scope.webhooks = $scope.paginator(function (options, callback) {
            return WebhookEvents.query(options, function () {
                callback();
                if (func)
                    func();
                func = null;
            });
        }, getSearchParams(), 20);
    };

    function init() {
        if (!$scope.search) {
            $scope.search = "";
        }
        $scope.updateFilter();
    }

    $scope.statusClass = function (status) {
        return PUtill.getStatusClass(status);
    };

    $scope.setStatus = function (status, defaultLabelName) {
        $scope.status = status.replace(' ', '');
        $scope.statusName = PUtill.getText(defaultLabelName || status);
        $scope.updateFilter();
    };

    $scope.setEvent = function (event, defaultLabelName) {
        $scope.hookEvent = event;
        $scope.eventName = PUtill.getText(defaultLabelName || event);
        $scope.updateFilter();
    };
    init();

};

WebhooksController.$inject = ['$scope', '$http', '$routeParams', 'WebhookEvents', 'PUtill'];
